"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteOpexService = exports.updateOpexService = exports.createOpexService = exports.getOpexsService = void 0;
const api_1 = require("@/services/api");
const CustomError_1 = __importDefault(require("@/domains/Utilities/CustomError"));
const ENDPOINT = "/opexs";
function getOpexsService() {
    return api_1.axiosInstance
        .get(`${ENDPOINT}`)
        .then((response) => {
        return response.data.rows;
    })
        .catch((error) => {
        throw new Error(`'[Get Opexs Error]: ${error}'`);
    });
}
exports.getOpexsService = getOpexsService;
function createOpexService(payload) {
    return api_1.axiosInstance
        .post(`${ENDPOINT}`, payload)
        .then((response) => {
        return response.data;
    })
        .catch((error) => {
        throw new CustomError_1.default("Error while creating opex", error?.response?.status);
    });
}
exports.createOpexService = createOpexService;
function updateOpexService(opexId, payload) {
    return api_1.axiosInstance
        .put(`${ENDPOINT}/${opexId}`, payload)
        .then((response) => {
        return response.data;
    })
        .catch((error) => {
        throw new CustomError_1.default("Error while creating system", error?.response?.status);
    });
}
exports.updateOpexService = updateOpexService;
function deleteOpexService(opexId) {
    return api_1.axiosInstance
        .delete(`${ENDPOINT}/${opexId}`)
        .then((response) => {
        return response.status;
    })
        .catch((error) => {
        throw new CustomError_1.default("Error while deleting system", error?.response?.status);
    });
}
exports.deleteOpexService = deleteOpexService;
